import './home.css';
import './christmas.css';

import CoinFlipWizardContainer from '../../components/coin-flip-wizard/CoinFlipWizard';

export const Home = () => <CoinFlipWizardContainer />;